/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { useLoaderData, useParams, useSubmit } from 'react-router-dom';
import { string, setLocale } from 'yup';
import CreateForm from '../components/Forms/CreateForm/CreateForm';
import FormWrapper from '../components/Forms/builders/FormWrapper';
import { phoneUS } from '../components/Forms/yup/customValidations';
import PhoneHelpTooltip from '../components/Forms/PhoneInput/PhoneHelpTooltip.tsx';
import useFormikTemplate from '../components/Forms/hooks/useFormikTemplate';

setLocale({
  mixed: {
    required: 'This is a mandatory field',
    default: 'Invalid input',
  },
  string: {
    email: 'Invalid e-mail format',
  },
});

function ContactFormPage() {
  // We still need to grab the token (probably as a qs as well)
  // and then send it to the action to check the validity
  // Another option could be adding it to a visaully hidden and disabled field

  // Get the QS data from the loader
  const { token, mobile } = useLoaderData();
  const { userId } = useParams();

  const contactForm = [
    {
      formGroup: 'Customer Information',
      groupChildren: [
        {
          name: 'last_name',
          label: 'First name',
          initialValue: '',
          type: string().required(),
          required: true,
        },
        {
          name: 'first_name',
          label: 'Last Name',
          initialValue: '',
          type: string().required(),
          required: true,
        },
        {
          name: 'email',
          label: 'Email',
          initialValue: '',
          type: string().email().required(),
          required: true,
        },
        {
          name: 'mobile_number',
          label: 'Mobile number',
          formType: 'phone',
          initialValue: mobile || '',
          type: phoneUS.required('Please enter a phone number'),
          required: true,
          labelAction: <PhoneHelpTooltip />,
        },
        {
          name: 'phone_number',
          label: 'Phone Number',
          formType: 'phone',
          initialValue: '',
          type: phoneUS,
          labelAction: <PhoneHelpTooltip />,
        },
        {
          name: 'fax',
          label: 'Fax Number',
          formType: 'phone',
          initialValue: '',
          type: phoneUS,
          labelAction: <PhoneHelpTooltip />,
        },
        {
          name: 'company',
          label: 'Company Name',
          initialValue: '',
          type: string(),
          className: 'input-wide',
        },
      ],
    },
    {
      formGroup: 'Billing Address',
      groupChildren: [
        {
          name: 'autocomplete_address',
          label: 'Search Address',
          initialValue: '',
          formType: 'autocompleteAddress',
          type: string(),
          fieldNames: {
            street: 'street_address_1',
            city: 'city',
            state: 'state',
            zipcode: 'zip',
            country: 'country',
          },
          required: false,
          className: 'input-wide',
        },
        {
          name: 'street_address_1',
          label: 'Street Address',
          initialValue: '',
          type: string().required(),
          required: true,
          autocomplete: 'address-line1',
        },
        {
          name: 'street_address_2',
          label: 'Street Address 2',
          initialValue: '',
          type: string(),
          required: false,
        },
        {
          name: 'city',
          label: 'City',
          initialValue: '',
          type: string().required(),
          required: true,
        },
        {
          name: 'state',
          label: 'State',
          initialValue: '',
          type: string().required(),
          required: true,
        },
        {
          name: 'zip',
          label: 'Zip Code',
          initialValue: '',
          type: string().required(),
          required: true,
        },
        {
          name: 'country',
          label: 'Country',
          initialValue: '',
          type: string().required(),
          required: true,
        },
      ],
    },
  ];

  const reactRouterSubmit = useSubmit();
  const submitAction = (values) => {
    reactRouterSubmit(
      {
        ...values,
        customer_token: token,
        user_id: userId,
      },
      {
        method: 'post',
        action: `/${userId}/create-form`,
        encType: 'application/json',
      }
    );
  };

  const [formik] = useFormikTemplate({
    initial: contactForm,
    yupValues: contactForm,
    submitAction,
    enableReinitialize: true,
    enableTransforms: true,
  });

  return (
    <>
      <FormWrapper
        id="new-customer-form-token"
        handleSubmit={formik.handleSubmit}
        isSubmitting={formik.isSubmitting}
        dirty={formik.dirty}
        isValid={formik.isValid}
        label="Create customer"
        portalId="contact-form-create-submit-container"
      >
        <CreateForm structure={contactForm} {...formik} />
      </FormWrapper>
      <div style={{ position: 'sticky', bottom: 0, right: 0 }}>
        <div
          className="sticky__submit-container"
          id="contact-form-create-submit-container"
        />
      </div>
    </>
  );
}

export default ContactFormPage;
